import { useEffect, useState } from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { useAuth } from '../contexts/AuthContext';
import { useTheme } from '../contexts/ThemeContext';
import { api } from '../services/api';
import { Box, Play, Music, ChevronRight, Sparkles, Sun, Moon } from 'lucide-react';
import '../styles/SharedStyles.css';

const Widgets = () => {
  const { t } = useLanguage();
  const { isActive, isAdmin } = useAuth();
  const { theme, toggleTheme } = useTheme();
  const [widgets, setWidgets] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (isActive || isAdmin) {
      api.widgets.getAll()
        .then(data => {
          setWidgets(Array.isArray(data) ? data : []);
          setLoading(false);
        })
        .catch(err => {
          console.error(err);
          setLoading(false);
        });
    }
  }, [isActive, isAdmin]);

  if (!isActive && !isAdmin) {
    return <div className="container text-center mt-8 text-danger">{t('accessDenied')}</div>;
  }

  const getIcon = (type) => {
    if (type === 'youtube') return Play;
    if (type === 'spotify') return Music;
    return Box;
  };

  const getIconColor = (type) => {
    if (type === 'youtube') return '#ef4444';
    if (type === 'spotify') return '#10b981';
    return '#38bdf8';
  };

  return (
    <div className={`shared-page ${theme}`}>
      <div className="glow-effect glow-1"></div>
      <div className="glow-effect glow-2"></div>
      <div className="container shared-content" style={{ paddingTop: '2rem', paddingBottom: '2rem' }}>

      <div className="shared-section-header">
        <h2>
          <Sparkles size={28} />
          {t('widgets')}
        </h2>
        <p>{t('widgetsPageSubtitle')}</p>
      </div>

      {loading ? (
        <div className="shared-loading">
          <div className="shared-spinner"></div>
          <span>{t('loading')}</span>
        </div>
      ) : widgets.length === 0 ? (
        <div className="shared-empty">
          <Box size={48} />
          <p>{t('noWidgets')}</p>
        </div>
      ) : (
        <div className="shared-grid">
          {widgets.map(widget => {
            const Icon = getIcon(widget.type);
            const color = getIconColor(widget.type);
            return (
              <div key={widget.id} className="shared-feature-card" style={{ '--card-color': color }}>
                <div className="shared-card-icon" style={{ backgroundColor: color }}>
                  <Icon size={28} />
                </div>
                <h3>{widget.title}</h3>
                <p className="shared-card-type">{t(widget.type)}</p>
                <p className="shared-card-desc">{widget.description || t('noDescription')}</p>
                <a href={widget.url} target="_blank" rel="noreferrer" className="shared-card-link">
                  {t('openWidget')}
                  <ChevronRight size={16} />
                </a>
                <div className="shared-card-arrow">
                  <ChevronRight size={20} />
                </div>
              </div>
            );
          })}
        </div>
      )}
      </div>
    </div>
  );
};

export default Widgets;
